// Portugal city guides for the LEARN pillar.

export const CITIES = [
  {
    slug: "lisbon",
    name: "Lisbon",
    tagline: "The capital of opportunity.",
    image: "https://images.unsplash.com/photo-1608208291890-dcaf52dc98e1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    bestFor: "Startups, tech, international business",
    overview:
      "Portugal's vibrant capital is the beating heart of its startup and business ecosystem. Home to the Web Summit, a thriving tech scene and a large international community, Lisbon offers the most opportunity — and the highest cost of living in the country.",
    costOfLiving: "€1,500–€2,200 / month (single)",
    housing: "1-bed €900–€1,400 central; suburbs cheaper",
    business: "Tech, tourism, services, finance, startups",
    lifestyle: "Cosmopolitan, coastal, nightlife, culture",
    community: "Large and growing Indian community",
    prosCons: { pros: ["Most business opportunity", "International, English-friendly", "Great connectivity to India via hubs"], cons: ["Highest cost of living", "Competitive rental market"] },
    whoFor: "Founders and professionals who want to be at the centre of Portugal's economy.",
  },
  {
    slug: "porto",
    name: "Porto",
    tagline: "Tradition meets ambition.",
    image: "https://images.unsplash.com/photo-1642197288459-a038450c6217?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    bestFor: "Trade, manufacturing, lifestyle founders",
    overview:
      "Portugal's proud second city blends world-famous heritage with a fast-growing business scene and a lower cost of living than Lisbon. Effizent Europe is headquartered here. Porto is ideal for founders who want opportunity without the capital's price tag.",
    costOfLiving: "€1,200–€1,800 / month (single)",
    housing: "1-bed €700–€1,100",
    business: "Trade, wine, textiles, tech, tourism",
    lifestyle: "Historic, riverside, authentic, walkable",
    community: "Established and welcoming Indian community",
    prosCons: { pros: ["Lower cost than Lisbon", "Strong business base", "High quality of life"], cons: ["Smaller international scene than Lisbon", "Rainier winters"] },
    whoFor: "Entrepreneurs seeking balance between opportunity, culture and affordability.",
  },
  {
    slug: "braga",
    name: "Braga",
    tagline: "Young, affordable, rising.",
    image: "https://images.unsplash.com/photo-1581858348434-86eed6d96970?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    bestFor: "Tech, students, families on a budget",
    overview:
      "One of Portugal's oldest cities is also one of its youngest in spirit — a growing university town with a booming technology sector and some of the lowest living costs in the country. Excellent for families and early-stage founders.",
    costOfLiving: "€1,000–€1,500 / month (single)",
    housing: "1-bed €500–€800",
    business: "Technology, engineering, education",
    lifestyle: "Relaxed, historic, family-friendly",
    community: "Growing Indian student and family community",
    prosCons: { pros: ["Very affordable", "Strong tech and university scene", "Safe and family-friendly"], cons: ["Smaller job market than Lisbon/Porto"] },
    whoFor: "Families, students and founders who value affordability and quality of life.",
  },
  {
    slug: "madeira",
    name: "Madeira",
    tagline: "The island of digital nomads.",
    image: "https://images.unsplash.com/photo-1585334954347-e50fe83cc6ce?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    bestFor: "Remote workers, digital nomads, lifestyle",
    overview:
      "A subtropical Atlantic island with a famous Digital Nomad Village, spring-like weather year round and attractive tax conditions. Madeira suits remote founders and professionals who want lifestyle alongside a European base.",
    costOfLiving: "€1,200–€1,700 / month (single)",
    housing: "1-bed €700–€1,100",
    business: "Remote work, tourism, digital services",
    lifestyle: "Nature, mild climate, outdoor, community",
    community: "Vibrant international nomad community",
    prosCons: { pros: ["Beautiful climate year round", "Digital nomad ecosystem", "Attractive tax regime"], cons: ["Island logistics", "Smaller local market"] },
    whoFor: "Digital nomads and remote-first founders who want lifestyle with an EU base.",
  },
];

export function getCity(slug) {
  return CITIES.find((c) => c.slug === slug);
}
